import { render, staticRenderFns } from "./CommodityDialog.vue?vue&type=template&id=31c0ad6e&"
import script from "./CommodityDialog.vue?vue&type=script&lang=js&"
export * from "./CommodityDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommodityDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommodityDialog.vue"
export default component.exports